/* eslint-disable */
import React, { useState, useEffect } from "react";
import Chat, { Bubble, RichText, Image, Flex, FlexItem, Input, ScrollView, Divider, useMessages, toast } from "@chatui/core";
import { charAnswer, getInitInfo, getNavBar, getBottomBar, clickNav, clickBot } from "../services/yoobot";
import QuestionEvaluate from "../components/questionEvaluate";
import Questionnaire from "../components/questionnaire";
import RenderRemind from "../components/questionList";
import { searchObj, renderText } from '../utils/util';
import "./customerService.css";
let { theme, game_id, gta_version_ios, sdkVersion } = searchObj(window.location.search)
gta_version_ios = gta_version_ios ? gta_version_ios : sdkVersion
const Composer = (questionClick) => {
	const [inpValue, setInpValue] = useState('');
	const valChange = (val) => {
		setInpValue(val)
	}
	const inpBlur = () => {
		window.scrollTo(0, 0);
	}
	const keyUp = (e) => {
		if (e.keyCode === 13) {
			questionClick(inpValue, 0, 0, null, null, 'text');
			window.scrollTo(0, 0);
		}
	}
	return <div className="composer_wrap">
		<Input value={inpValue} onKeyUp={keyUp} onBlur={inpBlur} onChange={valChange} placeholder="请输入..." />
		<div className="img_k">
			<img
				onClick={() => { questionClick(inpValue, 0, 0, null, null, 'text'); }}
				className="composer_img"
				src={inpValue ? require('../asset/imgs/send_on.png').default : (theme === '2' ? require('../asset/imgs/send_f.png').default : require('../asset/imgs/send.png').default)}
				alt='composer_img' />
		</div>
	</div>
}

const CustomerService = (props) => {
	const { messages, appendMsg, setTyping } = useMessages([]);
	const [pageIndex, setPageIndex] = useState(1);
	const [text] = useState(renderText('请输入您想咨询的问题'));
	const [serviceAvatar] = useState(
		window.location.hostname.indexOf('gtarcade') > -1 ? (theme === '2' ? 'https://oss.gtarcade.com/ucms/d9b63185-28ea-4bd0-9d44-d2e9ed8a5aed_2022-09-19.png' : 'https://oss.gtarcade.com/ucms/5c69df43-d1c4-4415-9ace-0c6f0287df35_2022-09-19.png') : (theme === '2' ? 'https://oss.youzu.com/y_web/41b84a85-a921-4bfa-897a-c3fcd4a5a185_2022-09-19.png' : 'https://oss.youzu.com/y_web/745e8680-db54-4c86-9867-956b9e5e882b_2022-09-19.png')
	);
	const [quickList, setQuickList] = useState([]);

	useEffect(() => {

		// 获取导航栏
		getNavBar({}).then((resp) => {
			appendMsg({
				type: "head",
				content: { list: resp.data },
				position: "center",
			});
			// 获取初始化信息
			getInitInfo({ page: pageIndex }).then((res) => {
				if (res.code === 0) {
					// 展示紧急提示
					if (res.data.notify) {
						appendMsg({
							type: "children",
							content: {
								children: renderHint(res.data.notify),
							},
							user: { avatar: serviceAvatar },
						});
					}
					if (res.data.welcome) {
						appendMsg({
							type: 'richText',
							content: { text: res.data.welcome || 'hi，我是智能客服小游，如果有遇到什么问题可以向我询问喔~' },
							user: { avatar: res.data.smart_icon || serviceAvatar },
						});
					}
					// 展示默认问题列表
					if (res.data.question && res.data.question.length > 0) {
						appendMsg({
							type: "children",
							content: {
								children: (
									<RenderRemind
										list={res.data.question}
										setPageIndex={setPageIndex}
										serviceAvatar={serviceAvatar}
										questionClick={questionClick}
										needRef={true}
									></RenderRemind>
								)
							},
							user: { avatar: serviceAvatar },
						});
					}
					// 展示默认工单回复
					if (res.data.auto_order) {
						appendMsg({
							type: "order",
							content: {
								info: res.data.auto_order
							},
							user: { avatar: serviceAvatar },
						});
					}
				}
			});
		});
		getBottomBar({}).then((res) => {
			const list = [];
			res.data.forEach(item => {
				list.push({ name: item.bottom_name, id: item.id })
			})
			setQuickList(list)
			appendMsg({
				type: "bottom",
				content: { list: res.data },
				position: "center",
			});
		});
	}, []);
	// 渲染紧急通知
	const renderHint = (textInfo, needOther, content) => {
		return (
			<div>
				<Flex wrap="wrap" style={{ maxWidth: "320px" }}>
					<FlexItem flex="1 0 auto" style={{ width: '100%' }}>
						<div style={{ minWidth: "250px" }}>
							<div
								style={{
									padding: "0px 5px",
									paddingBottom: "10px",
									position: "relative",
									borderBottom: "1px solid #F3F3F3",
								}}
							>
								<img
									style={{ width: '22px', verticalAlign: 'text-bottom' }}
									src="https://oss.youzu.com/y_web/4af91ceb-06f5-4bcb-bf58-ad7dc566e88a_2022-06-27.svg"
									alt='bubble'
								></img>
								<span className='Bubble_title' style={{ marginLeft: "5px" }}>
									{textInfo.question_title}
								</span>
							</div>
						</div>
					</FlexItem>
					<FlexItem flex="1 0 auto" style={{ width: '100%' }}>
						<div style={{ padding: "10px 5px", position: "relative", borderBottom: "1px solid #F3F3F3" }}>
							<RichText content={textInfo.question_answer}></RichText>
						</div>
					</FlexItem>
					{needOther && (
						<FlexItem flex="none">
							<div style={{ width: "250px" }}>
								<div
									onClick={() => {
										questionClick(content, 0, 1);
									}}
									style={{
										padding: "10px 5px",
										position: "relative",
										color: "#e09334",
									}}
								>
									【
									{renderText('other_qus')}
									】
								</div>
							</div>
						</FlexItem>
					)}
				</Flex>
			</div>
		);
	};
	// 对话组件

	// 点击头部导航栏
	const navClick = async (id) => {
		try {
			const res = await clickNav({ navigation_type: 1, id, page: 1 });
			if (res.code === 0 && res.data) {
				appendMsg({
					type: "children",
					content: {
						children: (
							<RenderRemind
								list={res.data.question}
								title={res.data.director_text}
								setPageIndex={setPageIndex}
								serviceAvatar={serviceAvatar}
								questionClick={questionClick}
								needRef={false}
							></RenderRemind>
						),
					},
					user: { avatar: serviceAvatar },
				});
			}
		} catch {
			appendMsg({
				type: "questionnaire",
				content: {
					text: renderText('当前网络状态不佳，请稍后再试')
				},
				user: { avatar: serviceAvatar },
			});
		}
	}
	// 点击底部导航栏
	const botClick = async (bot_id) => {
		try {
			const res = await clickBot({ bot_id })
			renderAns(res, null, bot_id, true)
		} catch {
			appendMsg({
				type: "questionnaire",
				content: {
					text: renderText('当前网络状态不佳，请稍后再试'),
				},
				user: { avatar: serviceAvatar },
			});
		}
	}

	const renderAns = (res, content, id, isBanner) => {
		if (res.code === 0) {
			const type = res.data.answer_status;
			switch (type) {
				// 1 匹配答案
				case 1:
					id = res.data.question_id ? res.data.question_id : id;
					appendMsg({
						type: "botQuestion",
						content: { text: res.data.answer_intro, id, isBanner },
						user: { avatar: serviceAvatar },
					});
					break;
				case 2:
					appendMsg({
						type: "children",
						content: {
							children: (
								<RenderRemind
									guide={1}
									guide_content={content}
									content={content}
									title={res.data.director_text}
									list={res.data.answer_intro}
									setPageIndex={setPageIndex}
									serviceAvatar={serviceAvatar}
									questionClick={questionClick}
									needRef={false}
								></RenderRemind>
							),
						},
						user: { avatar: serviceAvatar },
					});
					break;
				case 3:
					appendMsg({
						type: "children",
						content: {
							children: renderHint(res.data.answer_intro, true, content),
						},
						user: { avatar: serviceAvatar },
					});
					break;
				case 6:
					appendMsg({
						type: "order",
						content: {
							info: res.data.answer_intro
						},
						user: { avatar: serviceAvatar },
					});
					break;
				case 5:
					appendMsg({
						type: "richText",
						content: { text: res.data.director_text },
						user: { avatar: serviceAvatar },
					});
					res.data.answer_intro.forEach(item => {
						appendMsg({
							type: "richText",
							content: { text: item },
							user: { avatar: serviceAvatar },
						});
					})
					appendMsg({
						type: "botQuestion",
						content: { text: res.data.end_intro, id, isBanner },
						user: { avatar: serviceAvatar },
					});
					break;
				default:
					appendMsg({
						type: "questionnaire",
						content: {
							text: res.data.answer_intro,
						},
						user: { avatar: serviceAvatar },
					});
					break;
			}
			setTyping(false);
		}
	}
	//点击其他问题
	//点击问题 进行对话
	const questionClick = async (
		content,
		content_id,
		other_question = 0,
		guide,
		guide_content,
		type,
	) => {
		content = content.trim()
		if (type === "text") {
			if (!content) return
			if (content.length >= 120) {
				content = content.slice(0, 120)
				toast.show(renderText('超出最大文案120字'))
			}
			appendMsg({
				type: "text",
				content: { text: content },
				position: "right",
			});
		}
		setTyping(true);
		try {
			const res = await charAnswer({
				content,
				content_id,
				other_question,
				guide: guide ? guide : 0,
				guide_content: guide_content ? guide_content : ''
			});
			renderAns(res, content, content_id)
		} catch {
			appendMsg({
				type: "questionnaire",
				content: {
					text: renderText('当前网络状态不佳，请稍后再试')
				},
				user: { avatar: serviceAvatar },
			});
			setTyping(true);
		}
	};

	function renderMessageContent(msg) {
		const { type, content } = msg;
		// 根据消息类型来渲染
		switch (type) {
			case "text":
				return <Bubble content={content.text} />;
			case "image":
				return (
					<Bubble type="image">
						<img src={content.picUrl} alt="" />
					</Bubble>
				);
			case "children":
				return (
					<Bubble style={{ padding: "20px", marginRight: "40px" }}>
						{content.children}
					</Bubble>
				);
			case "richText":
				return (
					<Bubble>
						<RichText content={content.text} />
					</Bubble>
				);
			case "repair":
				return <Bubble>{content.children}</Bubble>;
			case "botQuestion":
				return (
					<Bubble>
						<RichText
							content={content.text}
							style={{ overflowX: "auto" }}
						/>
						<Divider />
						<QuestionEvaluate
							question={content.question}
							question_id={content.id}
							serviceAvatar={serviceAvatar}
							appendMsg={appendMsg}
							isBanner={content.isBanner}
						/>
					</Bubble>
				);
			case "questionnaire":
				return (
					<Bubble>
						<RichText style={{ fontSize: "13px" }} content={content.text}></RichText>
						<Divider />
						<Questionnaire
							history={props.history}
							location={props.location}
						/>
					</Bubble>
				);
			case 'order':
				return (<Bubble>
					<Flex wrap="wrap" style={{ maxWidth: "320px" }}>
						<FlexItem flex="1 0 auto" style={{ width: '100%' }}>
							<div style={{ minWidth: "250px" }}>
								<div className="order_title" style={{ padding: "0px 0px", paddingBottom: "10px", position: "relative", borderBottom: "1px solid #F3F3F3" }}>
									<span style={{ marginLeft: "5px" }}>
										{renderText('ques_ans')}
									</span>
								</div>
							</div>
						</FlexItem>
						<FlexItem flex="1 0 auto" style={{ width: '100%' }}>
							<div className={`qus_wrap`}>
								<div className={`qus_title`} >
									{renderText('question')}:
								</div>
								<div className={`qus_desc`}>
									<span>
										{content.info.title}
									</span>
								</div>
							</div>
						</FlexItem>
						<FlexItem flex="1 0 auto" style={{ width: '100%' }}>
							<div style={{ minWidth: "250px" }} className={`qus_wrap`}>
								<div className={`qus_title`}>
									{renderText('order_num')}:
								</div>
								<div className={`qus_desc`}>
									<span >
										{content.info.id}
									</span>
								</div>
							</div>
						</FlexItem>
						<FlexItem flex="1 0 auto" style={{ width: '100%' }}>
							<div style={{ minWidth: "250px" }} className={`qus_wrap`}>
								<div
									className={`qus_title`}
								>
									{renderText('response')}:
								</div>
								<div className={`qus_desc qus_ans`}>
									<RichText content={content.info.answer}>
									</RichText>
								</div>
							</div>
						</FlexItem>
						<FlexItem flex="1 0 auto" style={{ width: '100%' }}>
							<div style={{ minWidth: "250px" }} className="order_foter">
								<img
									className="order_foter_icon"
									src={require('../asset/imgs/icon_arrow.png').default}
									alt='order_foter_icon'
								/>
								<span>
									{renderText('user_ask')}
								</span>
								<span
									onClick={() => {
										if (window.location.host.indexOf('gtarcade') > -1) {
											if (window.location.hostname.indexOf('prv') > -1) {
												window.location.href = `https://qamsupport.gtarcade.com/default/verify${props.location.search}&callback_url=${encodeURIComponent(`http://qasupport.gtarcade.com/aiservice/mytickets/details?gid=${game_id}&qid=${content.info.id}&ismod=1&theme=${theme}${gta_version_ios ? `&gta_version_ios=${gta_version_ios}` : ''}`)}`
											} else {
												window.location.href = `https://msupport.gtarcade.com/default/verify${props.location.search}&callback_url=${encodeURIComponent(`http://support.gtarcade.com/aiservice/mytickets/details?gid=${game_id}&qid=${content.info.id}&ismod=1&theme=${theme}${gta_version_ios ? `&gta_version_ios=${gta_version_ios}` : ''}`)}`
											}
										} else {
											props.history.push({ pathname: '/myWorkOrder', search: props.location.search })
										}
									}}
									style={{ marginLeft: "5px", color: "#e09334" }}>
									【{renderText('click_here')}】
								</span>
							</div>
						</FlexItem>
					</Flex>
				</Bubble>
				)
			case "head":
				return (
					<ScrollView
						style={{ paddingBottom: "14px" }}
						data={content.list}
						renderItem={(item) => (
							<div
								className="sc_header"
								style={{
									marginRight: "8px",
									background: "var(--white)",
									borderRadius: "10px",
									width: "70px",
									margin: "5px",
									height: '100%',
									boxShadow:
										"0px 0px 5px 4px rgba(0, 0, 0, 0.01)",
								}}
							>
								<Flex
									direction="column"
									justifyContent="center"
									alignItems="stretch"
									onClick={() => {
										if (item.navigation_type === 2) {
											if (window.location.href.indexOf("gtarcade") > -1) {
												if (window.location.hostname.indexOf('prv') > -1) {
													if (item.sheet_number) {
														const template_id = item.sheet_number.split(',')[1];
														const parent_type = item.sheet_number.split(',')[0];
														window.location.href = "https://qamsupport.gtarcade.com/default/verify" + props.location.search + `&callback_url=${encodeURIComponent('http://qasupport.gtarcade.com/aiservice/search/submit?gid=' + game_id + '&template_id=' + template_id + '&parent_type=' + parent_type + '&theme=' + theme + (gta_version_ios ? ('&gta_version_ios=' + gta_version_ios) : ''))}`
													} else {
														window.location.href = "https://qamsupport.gtarcade.com/default/verify" + props.location.search + `&callback_url=${encodeURIComponent('http://qasupport.gtarcade.com/aiservice/search/choose-form?gid=' + game_id + '&theme=' + theme + (gta_version_ios ? ('&gta_version_ios=' + gta_version_ios) : ''))}`
													}
												} else {
													if (item.sheet_number) {
														const template_id = item.sheet_number.split(',')[1];
														const parent_type = item.sheet_number.split(',')[0];
														window.location.href = "https://msupport.gtarcade.com/default/verify" + props.location.search + `&callback_url=${encodeURIComponent('http://support.gtarcade.com/aiservice/search/submit?gid=' + game_id + '&template_id=' + template_id + '&parent_type=' + parent_type + '&theme=' + theme + (gta_version_ios ? ('&gta_version_ios=' + gta_version_ios) : ''))}`
													} else {
														window.location.href = "https://msupport.gtarcade.com/default/verify" + props.location.search + `&callback_url=${encodeURIComponent('http://support.gtarcade.com/aiservice/search/choose-form?gid=' + game_id + '&theme=' + theme + (gta_version_ios ? ('&gta_version_ios=' + gta_version_ios) : ''))}`
													}
												}
											} else {
												if (item.sheet_number) {
													props.history.push({ pathname: '/workOrderSubmit', search: props.location.search, query: { tplId: item.sheet_number } })
												} else {
													props.history.push({
														pathname: "/workOrderList",
														search:
															props.location.search,
													});
												}
											}
										} else {
											navClick(
												item.id,
												0,
												0
											);
										}
									}}
								>
									<FlexItem
										alignSelf="auto"
										style={{
											textAlign: "center",
											height: "50px",
											padding: "5px 10px 0 10px",
										}}
									>
										<div
											style={{
												height: "50px",
												width: "50px",
												overflow: "hidden",
											}}
										>
											<Image
												src={item.navigation_icon}
												width="50"
												height="50"
												lazy
												fluid
												style={{
													height: '100%',
													objectFit: 'cover',
													borderRadius: '10px'
												}}
											/>
										</div>
									</FlexItem>
									<FlexItem
										alignSelf="auto"
										style={{
											textAlign: "center",
											fontSize: "12px",
										}}
									>
										<div>
											{item.navigation_name}
										</div>
									</FlexItem>
								</Flex>
							</div>
						)}
					/>
				);
			default:
				return null;
		}
	}

	return (
		<div className={`contain ${theme === '1' ? 'black' : 'white'}`}>
			<Chat
				navbar={window.location.href.indexOf('gtarcade') > -1 ? false : {
					title: renderText('客服中心'),
					leftContent: {
						icon: "close",
						color: "primary",
						onClick: () => (window.location.replace(`${window.location.origin}/closeWin`)),
					}
				}}
				Composer={() => Composer(questionClick)}
				placeholder={text}
				messages={messages}
				quickReplies={quickList}
				renderMessageContent={renderMessageContent}
				onQuickReplyClick={(info) => { botClick(info.id) }}
				onSend={(type, val) => {
					questionClick(val, 0, 0, null, null, type);
				}}
			/>
		</div>
	);
};

export default CustomerService;
